<div [attr.aria-describedby]="header ? 'modal-header' : undefined"
     cdkTrapFocus
     class="modal-content"
     role="dialog">
  <div *ngIf="header"
       class="modal-header"
       id="modal-header">
    <h5 class="modal-title pull-left">
      <ng-content select=".header"></ng-content>
    </h5>
    <button (click)="baseModalService.close()"
            class="close pull-right"
            type="button"
            role="button">
      <span aria-hidden="true">&times;</span>
      <span class="sr-only">{{'base.close_modal' | transloco}}</span>
    </button>
  </div>
  <div class="modal-body">
    <ng-content></ng-content>
  </div>
  <ng-content select=".append"></ng-content>
  <div *ngIf="footer" class="modal-footer">
    <ng-content select=".footer"></ng-content>
  </div>
</div>
